
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ProductedRoute from './componenets/ProductedRoute';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { getUser } from './services/api/api';
import { setUserDetails } from "./redux/slice/user";

import Login from "./pages/Login"
import Error from './pages/Error';
import Home from './pages/Home';
import Studios from './pages/Studios';
import Addons from './pages/addons/Addons';
import Leads from './pages/leads/Leads';
import Availability from './pages/Availability';

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Users from './pages/teams/Users';
import TeamLeads from './pages/teams/TeamLeads';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';

function App() {
  const theme = useSelector((state) => state.theme.value);
  const [themeName, setthemeName] = useState(
    theme === "dark" ? "mdc-dark-indigo" : "mira"
  );

  // theme change
  useEffect(() => {
    setthemeName(theme === "dark" ? "mdc-dark-indigo" : "mira");
  }, [theme]);
  
  useEffect(() => {
    const existingTheme = document.getElementById("theme-style");
    if (existingTheme) {
      existingTheme.remove();
    }
    const link = document.createElement("link");
    link.id = "theme-style";
    link.rel = "stylesheet";
    link.href = `https://unpkg.com/primereact/resources/themes/${themeName}/theme.css`;
    document.head.appendChild(link);
  }, [themeName]);

  const dispatch = useDispatch();
  const key = "MY-PHOTOGRAPHY-CRM-PROJECT";
  const users = useSelector((state) => state.user);    
  const [loading, setLoading] = useState(true);
  const sessionId = localStorage.getItem('sessionId'); 
  const [isLoggedIn,setIsLoggedIn] = useState(sessionId ? true : false);
  let inactivityTimeout;

  // inactive logout
  const inactiveUser = () => {
    localStorage.clear();
    localStorage.setItem('logoutSuccess', 'Session Expired!');
    window.location.href = '/login';
  };

  // timer for user active
  const activeUser = () => {
    clearTimeout(inactivityTimeout);
    inactivityTimeout = setTimeout(() => {
      inactiveUser();
    }, 5 * 60 * 1000);   // 5 minutes
  };

  // check user acivity
  useEffect(() => {   
    if (users.loggedin === 'yes') {
      activeUser();
      const activityEvents = ['mousemove', 'keypress', 'click', 'keydown', 'keyup', 'scroll', 'touchstart', 'touchend', 'contextmenu'];
      activityEvents.forEach(event => {
          window.addEventListener(event, activeUser);
      });
      return () => {
        activityEvents.forEach(event => {
            window.removeEventListener(event, activeUser);
        });
        clearTimeout(inactivityTimeout);
      };
    }
  });

  // get user data
  useEffect(()=>{
    if(localStorage.getItem('sessionId')){
      const bytes = AES.decrypt(sessionId, key);
      const token = bytes.toString(Utf8);
      getUser(token)
        .then(response=>{

          
          if (response.status){
            const userdetails = {
              ID: response?.data?.user.superadmin_id,
              UserName: response?.data?.user.name,
              UserRole: response?.data?.user.role,
              UserEmail: response?.data?.user.email,
              TeamLeadID: response?.data?.user.teamlead_id,
              UserID: response?.data?.user.user_id,
            }
            const isLogin = 'yes';
            dispatch(setUserDetails({ userdetails, isLogin }));
            const new_token = AES.encrypt(response.new_token, key).toString();
            localStorage.setItem('sessionId', new_token);  
          } else {
            localStorage.clear();
            localStorage.setItem('logoutSuccess', 'Session Expired!');
            window.location.href = '/login';
          }
        })
        .catch(()=>{
          localStorage.clear();
          localStorage.setItem('logoutSuccess', 'Session Expired!');
          window.location.href = '/login';
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  },[]);

  // check user logged in
  useEffect(() => {
    if (!loading) {
      if (users.loggedin === 'yes' && users.userDetails.ID !== "" && users.userDetails.UserName !== "" && users.userDetails.UserRole !== "") {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }
  }, [loading, users]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/superadmin-custom-hidden" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="*" element={<Error />} />
        <Route path="/" element={<ProductedRoute isLoggedIn={isLoggedIn}><Home /></ProductedRoute>} />
        <Route path="/studios" element={<ProductedRoute isLoggedIn={isLoggedIn}><Studios /></ProductedRoute>} />
        <Route path="/addons/:type" element={<ProductedRoute isLoggedIn={isLoggedIn}><Addons /></ProductedRoute>} />
        <Route path="/leads/:status" element={<ProductedRoute isLoggedIn={isLoggedIn}><Leads /></ProductedRoute>} />
        <Route path="/availability" element={<ProductedRoute isLoggedIn={isLoggedIn}><Availability /></ProductedRoute>} />
        <Route path="/teamleads" element={<ProductedRoute isLoggedIn={isLoggedIn}><TeamLeads /></ProductedRoute>} />
        <Route path="/users" element={<ProductedRoute isLoggedIn={isLoggedIn}><Users /></ProductedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;

